module.exports = __webpack_public_path__ + "static/media/cross.30e45aeb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/components/header/assets/cross.png
 ** module id = 554
 ** module chunks = 0
 **/